module.exports = __webpack_public_path__ + "static/media/Upload.dafa0f40.svg";